module.exports = __webpack_public_path__ + "img/AbouUs.daff57ed.png";